import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-tooltip-modal',
    templateUrl: './tooltip-modal.component.html',
})
export class TooltipModalComponent {
  @Input() content = '';
}
